import { defineMessages } from "react-intl";

const PREFIX = "EmailConfirmedPage";
export default defineMessages({
  header: {
    id: `${PREFIX}.header`,
    defaultMessage: "Restoring account password successfully completed. Please, check your e-mail for the confirmation link. If you haven't received an e-mail, please contact <a href='mailto:ivan.zlatkovic@basf.com' class='Auth-Link'> to your portal administrator.</a>",
  },
});
